/** Expedition Loadout's first-run walkthrough on Glow Cave: the steps and what each one accepts. */
import type { WalkthroughStep } from '@ka/ui';

/** Glow Cave: the tunnel is dark, so the torch is the first thing to pack. */
export const WALK_ADVENTURE = 'glow-cave';
export const WALK_ITEM = 'torch';

export interface ExpeditionWalkthroughHost {
  goal: () => Element | null | undefined;
  /** The torch tile on the shelf. */
  item: () => Element | null | undefined;
  backpack: () => Element | null | undefined;
  shelf: () => Element | null | undefined;
}

export function expeditionSteps(h: ExpeditionWalkthroughHost): WalkthroughStep[] {
  return [
    {
      id: 'ahead',
      say: 'Read what’s ahead',
      hint: 'The tunnel is very dark. What would help?',
      target: h.goal,
      button: 'Got it',
    },
    { id: 'pack', say: 'Pack a torch', hint: 'Tap the torch on the shelf.', target: h.item },
    {
      id: 'backpack',
      say: 'It’s in your backpack',
      hint: 'It takes 1 of 12 slots. Later, tap it there to take it out.',
      target: h.backpack,
      button: 'Got it',
    },
    {
      id: 'rest',
      say: 'Pack the rest',
      hint: 'Pack what you need for what’s ahead. Then press Start.',
      target: h.shelf,
      button: 'Done',
    },
  ];
}

/** Whether packing item `id` belongs to step `step`. */
export const walkPackOk = (step: string | null, id: string) => step === 'pack' && id === WALK_ITEM;
